'use client';

import { useDrawer } from '@cat-ecom/pcc-components';
import { FC, PropsWithChildren, createContext, useContext } from 'react';

const NotificationsDrawerContext =
  createContext<ReturnType<typeof useDrawer>>(null);
export const useNotificationsDrawer = () =>
  useContext(NotificationsDrawerContext);

export const NotificationsDrawerProvider: FC<PropsWithChildren> = ({
  children
}) => {
  const notificationsDrawer = useDrawer();

  return (
    <NotificationsDrawerContext.Provider value={notificationsDrawer}>
      {children}
    </NotificationsDrawerContext.Provider>
  );
};
